// extracted by mini-css-extract-plugin
module.exports = {"button":"PDFDownloadLink_button__2nNlR"};